import Field from '../Field'

interface CodeflFieldInterface {
    classNames: string;
    value: any;
    onChange: Function;
    onFocus: Function;
    error: any;
    fieldClassNames?: string;
    readonly?: boolean;
}

export const CodeflField = ({
    classNames,
    value,
    onChange,
    onFocus,
    error,
    fieldClassNames,
    readonly = false,
}: CodeflFieldInterface) => {
    return (
        <Field
            label="Identifiant"
            placeholder="Identifiant"
            labelRequired={true}
            name="codefl"
            classNames={classNames}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            error={error}
            fieldClassNames={fieldClassNames}
            readonly={readonly}
        />
    )
}
